import { LinkProps } from "react-aria-components";
import { MdsIconKind } from "@/design-system/components/icon";
import { ReactNode } from "react";

export type ChipColor = "default" | "grey";

export enum ChipVariant {
  Default = "default",
  Source = "source",
}

export interface MDSChipProps extends Omit<LinkProps, "children"> {
  iconKind?: MdsIconKind;
  icon?: ReactNode;
  children: React.ReactNode;
  maxWidth?: number | string;
  color?: ChipColor;
  variant?: ChipVariant;
  onRemove?: () => void;
}
